export default __webpack_public_path__ + "static/media/icon-menu-test-active.3a0d5d2d.svg";